import React from 'react';
import { Color } from 'modules/styles/colors';

export default (props: any = { color: Color.graySidebarIcon }) => ({
  svg: (
    <g id="AccountShare" stroke="none" strokeWidth={1} fill={props.color} fillRule="evenodd">
      <g id="Group-10" fill={props.color}>
        <path
          d="M20.40025,1.88072857 C19.5543214,0.745085714 18.2125357,0.000371428571 16.6859643,0.000371428571 C14.2178214,0.000371428571 12.2195357,1.92994286 12.0718929,4.36187143 C13.9485357,5.26537143 15.3200357,7.03987143 15.6645357,9.16537143 C15.9941786,9.23872857 16.3349643,9.28608571 16.6859643,9.28608571 C18.2125357,9.28608571 19.5543214,8.54044286 20.40025,7.4048 C20.9768929,6.6313 21.3288214,5.6823 21.3288214,4.64322857 C21.3288214,3.60322857 20.9768929,2.65422857 20.40025,1.88072857"
          id="Fill-1"
        />
        <path
          d="M25.9716786,16.0890786 C25.9698214,15.3100071 25.6151071,14.62565 25.0431071,14.0304357 C23.9938214,12.93565 22.1961071,12.1510071 20.40025,11.6792929 C19.04825,11.3245786 17.7018214,11.1425786 16.6859643,11.1425786 C16.3786071,11.1425786 16.0350357,11.1639357 15.6756786,11.1964357 C15.4175357,12.8957214 14.5056786,14.3749357 13.2010357,15.37315 C15.6524643,15.95165 18.1976786,17.0185786 19.5051071,18.57115 L20.40025,18.57115 L25.0431071,18.57115 L25.9716786,18.57115 L25.9716786,18.57115 L25.9716786,16.0955786 C25.9716786,16.0927929 25.9716786,16.0909357 25.9716786,16.0890786"
          id="Fill-3"
        />
        <path
          d="M9.28552857,14.8571429 C11.8511714,14.8571429 13.9283857,12.7799286 13.9283857,10.2142857 C13.9283857,7.64864286 11.8511714,5.57142857 9.28552857,5.57142857 C6.71988571,5.57142857 4.64267143,7.64864286 4.64267143,10.2142857 C4.64267143,12.7799286 6.71988571,14.8571429 9.28552857,14.8571429"
          id="Fill-5"
        />
        <g id="Group-9" transform="translate(0.000000, 16.714286)">
          <path
            d="M9.28552857,0 C6.18688571,0 -0.000185714286,1.65842857 -0.000185714286,4.95207143 L-0.000185714286,7.42857143 L18.5712429,7.42857143 L18.5712429,4.95207143 C18.5712429,1.65842857 12.3841714,0 9.28552857,0"
            id="Fill-7"
          />
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 26 25'
});
